import * as PIXI from 'pixi.js';
import { Scene } from "pixi-scenegraph";
import { createMenuItem, createPanel, createText, trunc } from '@/ui/menu-builder';
import { HEIGHT, WIDTH } from "@/constants";
import { Fx } from "@/audio/audio";
import { store } from "@/model/store";
import game from "@/model/game";
import { popIn } from '@/util/tween';

const BUTTON_HEIGHT = 40, PADDING = BUTTON_HEIGHT * 0.5;

export class FailScene extends Scene  {

    chartStats = {
        id: 'CHART ID Placeholder value',
        progress: 0,
        newProgress: 0
    }

    constructor() {
        super("fail"); // this is the scene name
        this.initBackground()
        const panel = createPanel({
            x: WIDTH / 2,
            y: HEIGHT / 2,
            width: 650,
            height: 400,
            scale: 1.8,
            headerText: '',
            variation: '10'
        });

        panel.width *= 1.6;
        this.addChild(panel);
        
        const back = createMenuItem({
            text: 'Select another song', 
            yCoord: 600,
            variation: '15',
            clickActionName: 'NAVIGATE',
            clickActionPayload: {
                sceneName: 'select-song'
            }
        });
        const restart = createMenuItem({
            text: 'Restart', 
            yCoord: 670,
            variation: '15',
            clickActionName: 'RESTART'
        });

        const { id, progress, newProgress} = this.chartStats;
        const text = createText({
            text: `Chart: ${trunc(id, 24)}\n\nProgress: ${Number(newProgress || 0).toFixed(2)}%\nBest: ${Number(progress || 0).toFixed(2)}%`,
            align: 'left'
        });
        this.chartStatsText = text;
        text.position.set(WIDTH / 2 - 190, 360);
        text.anchor.set(0, 0);
        this.addChild(text);
        this.addChild(back);
        this.addChild(restart);
    }

    initBackground() {
        const background = PIXI.Sprite.from('public/images/background.jpeg');
        background.width = WIDTH;
        background.height = HEIGHT;
        background.anchor.set(0.5, 0.5)
        background.position.set(WIDTH/2, HEIGHT/2)
        // background.scale.set(2,2)
        this.addChild(background);
    }

    setPayload(chartStats) {
        this.chartStats = chartStats;
        const { id, progress, newProgress} = this.chartStats;
        this.chartStatsText.text = `Chart: ${trunc(id, 24)}\n\nProgress: ${Number(newProgress || 0).toFixed(2)}%\nBest: ${Number(progress || 0).toFixed(2)}%`;
    }

    onReveal() {
        Fx.youLose.play();
        store.updateChartStats(this.chartStats.id, {
            ...this.chartStats,
            played: Date.now()
        });
        game.reset();
        this.children.forEach(child => popIn(child))
    }

}